export type Card = number; // 0..51: suit * 13 + rank

export const NUM_CARDS = 52;
export const RANK_CHARS = '23456789TJQKA';
export const SUIT_CHARS = 'cdhs';

export function rankOf(c: Card): number {
  return c % 13;
}

export function suitOf(c: Card): number {
  return Math.floor(c / 13);
}

export function makeCard(suit: number, rank: number): Card {
  return suit * 13 + rank;
}

export function cardToString(c: Card): string {
  if (!Number.isInteger(c) || c < 0 || c >= NUM_CARDS) throw new Error(`invalid card: ${c}`);
  return RANK_CHARS[rankOf(c)]! + SUIT_CHARS[suitOf(c)]!;
}

export function stringToCard(s: string): Card {
  if (s.length !== 2) throw new Error(`invalid card string: ${s}`);
  const rank = RANK_CHARS.indexOf(s[0]!);
  const suit = SUIT_CHARS.indexOf(s[1]!);
  if (rank < 0 || suit < 0) throw new Error(`invalid card string: ${s}`);
  return makeCard(suit, rank);
}

export function canonicalDeck(): Card[] {
  return Array.from({ length: NUM_CARDS }, (_, i) => i);
}
